<template>
  <div class="ma-0 pa-0">
    <v-btn
      color="info"
      text
      @click="previous()"
      :disabled="disabledPrevious"
      class="pl-0"
    >
      <v-img
        src="../../../assets/icons/anterior.png"
        style="cursor: pointer"
        alt="anterior"
        max-width="25"
        max-height="30"
        dark
      />{{ $tc("gestionEmpleados.previous") }}
    </v-btn>
    <v-btn
      color="info"
      text
      @click="next()"
      :disabled="disabledNext"
      class="pr-0"
      >{{ $tc("gestionEmpleados.next") }}
      <v-img
        src="../../../assets/icons/siguiente.png"
        style="cursor: pointer"
        alt="siguiente"
        max-width="25"
        max-height="30"
        dark
      />
    </v-btn>
  </div>
</template>

<script>
import changeTimePattern from "../../../store/gestionTiempos/changeTimePattern";
import assignTags from "../../../store/etiquetas/tags";
export default {
  data() {
    return {
      disabledNext: false,
      disabledPrevious: false,
      currentFormData: this.$store.state.employees.itemsEmployed,
      oldFormData: { ...this.$store.state.employees.itemsEmployed },
    };
  },
  props: {
    title: String,
  },

  methods: {
    next() {
      let items = this.$store.state.employees.employees;

      let itemNext;
      for (let i = 0; i < items.length; i++) {
        if (items[i].empId === this.currentFormData.empId) {
          itemNext = items[i + 1];
        }
      }

      this.viewEmployed(itemNext);
    },
    previous() {
      let items = this.$store.state.employees.employees;

      let itemPrevious;
      for (let i = 0; i < items.length; i++) {
        if (items[i].empId === this.currentFormData.empId) {
          itemPrevious = items[i - 1];
        }
      }

      this.viewEmployed(itemPrevious);
    },

    viewEmployed(item) {
      this.currentFormData = item;
      localStorage.setItem("empId", item.empId);

      this.$store.commit("employees/setItemsEmployed", item);
      this.disabledNext = false;
      this.disabledPrevious = false;
      this.disabledButtons();
      if (this.title) {
        this.dispachers();
        this.$router.push(`/gestionEmpleados/info/${item.empId}/${this.title}`);
      } else {
        this.$router.push(`/gestionEmpleados/info/${item.empId}`);
      }
    },

    disabledButtons() {
      let items = this.$store.state.employees.employees;
      if (this.currentFormData.empId == items[0].empId) {
        this.disabledPrevious = true;
      }

      if (this.currentFormData.empId == items[items.length - 1].empId) {
        this.disabledNext = true;
      }
    },
    dispachers() {
      switch (this.title) {
        case "Grupos":
          this.$store.dispatch("changeGroup/getGroupsAssigned");
          break;
        case "Pautas":
          changeTimePattern.dispatch("getTimePattern");
          break;
        case "Horarios":
          this.$store.dispatch("changeSchedule/getEmployedSchedule");
          break;
        case "Modelos":
          this.$store.dispatch("changeSettlementModel/getModelEmployed");
          break;
        case "Atributos":
          this.$store.dispatch("atributes/getAtributes");
          break;
        case "Tarjetas":
          this.$store.dispatch("assignCards/getCards");
          break;
        case "Saldos":
          this.$store.dispatch("accountBalances/getAccountBalances");
        case "Relojes":
          this.$store.dispatch("assignWatches/getWatchesAsign");
          break;
        case "Etiquetas":
          this.$store.dispatch("tags/getOneEmpTags");
          break;
        case "Permisos":
          this.$store.dispatch("permissions/getPermissions");
          break;
        default:
          break;
      }
    },
  },
};
</script>
